import React from "react";
import ReactDOM from "react-dom";

import "./css/LandingMenu.css";

import { MdOutlineClose } from "react-icons/md";
import { ButtonPrimary } from "../../../components/Buttons";
import { NavLink } from "react-router-dom";
import useOnClickOutside2 from "../../../hooks/useOnClickOutside2";

export function LandingMenu({ closeMenuHandler, className }) {
  const menuRef = useOnClickOutside2(closeMenuHandler);

  return (
    <section className={`landing-menu ${className}`} ref={menuRef}>
      <div className="top">
        <div className="left">
          <span className="logo">
            <span>Physio</span>
            <span>Track</span>
          </span>
        </div>
        <div className="right">
          <ButtonPrimary
            iconStart={
              <MdOutlineClose
                style={{
                  fontSize: "1.8rem",
                  color: "var(--blue-600)",
                }}
              />
            }
            variant={"icon"}
            onClick={closeMenuHandler}
            style={{ background: "none", borderColor: "var(--blue-500)" }}
          />
        </div>
      </div>
      <nav className="mid">
        <ul>
          <li>
            <NavLink onClick={closeMenuHandler} to="/welcome">
              Home
            </NavLink>
          </li>
          <li>
            <NavLink onClick={closeMenuHandler} to="/about-us">
              About us
            </NavLink>
          </li>
          <li>
            <NavLink onClick={closeMenuHandler} to="/contact-us">
              Contact us
            </NavLink>
          </li>
          <li>
            <NavLink onClick={closeMenuHandler} to="/login">
              Login
            </NavLink>
          </li>
          <li>
            <NavLink onClick={closeMenuHandler} to="/register">
              Sign up
            </NavLink>
          </li>
        </ul>
      </nav>
    </section>
  );
}

function LandingMenuPortal(props) {
  return ReactDOM.createPortal(<LandingMenu {...props} />, document.body);
}

export default LandingMenuPortal;
